import { render } from "./Pages.vue?vue&type=template&id=9ffe3438"
import script from "./Pages.vue?vue&type=script&lang=js"
export * from "./Pages.vue?vue&type=script&lang=js"

import "./Pages.vue?vue&type=style&index=0&id=9ffe3438&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.22.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__